import { useEffect, useRef } from 'react';

interface UseIdleTimeoutProps {
  onTimeout: () => void;
  timeoutMs?: number; // default is 120 minutes
}

export default function useIdleTimeout({ onTimeout, timeoutMs = 120 * 60 * 1000 }: UseIdleTimeoutProps) {
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const handleActivity = () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      timerRef.current = setTimeout(() => {
        onTimeout();
      }, timeoutMs);
    };

    // Events to monitor user activity
    const events = ['mousemove', 'keydown', 'click', 'touchstart', 'scroll'];

    // Setup initial timer
    handleActivity();

    // Register event listeners
    events.forEach(event => {
      window.addEventListener(event, handleActivity);
    });

    // Cleanup
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      events.forEach(event => {
        window.removeEventListener(event, handleActivity);
      });
    };
  }, [onTimeout, timeoutMs]);
}
